import { classes } from 'src/modules/shared/utils/styles.util';

export const DetailsFieldActionSkeleton = ({
  className,
}: {
  className?: string;
}) => (
  <div
    className={classes(
      'h-[34px] w-[34px] flex-shrink-0 animate-pulse rounded-xl bg-secondary-100',
      className
    )}
    aria-hidden="true"
  />
);
